import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import DropDownComp from "../../components/DropDownComp";
import ReduxAside1 from "./Aside1";
import { useMyContext } from "../../MyContext";
import { useNavigate } from "react-router-dom";
import { AiOutlineSave } from "react-icons/ai";
// Redux implement in Workbook
import { ActionCreators } from "redux-undo";
import { useSelector, useDispatch } from "react-redux";
import {
  getL1SheetProperty,
  getWorkbookProperty,
  selectTodoDescriptionsProxy,
} from "./WorkbookSlice";
import BackButtonDetector from "./components/WorkbookComponets/BackButtonDetector";
import VizStyle from "./components/WorkbookPopups/VizStyle";
import Aside2 from "./Aside2";
import Aside3 from "./Aside3";
import PublishWorkbook from "./components/WorkbookPopups/PublishWorkbook";
import DraftSaveComponent from "./components/WorkbookComponets/DraftSaveComponent";
import Footer from "./Footer";
import Dashboard from "./dashboard/Dashboard";
import {
  useGetVizardDataMutation,
  usePatchWorkbookMutation,
  useScreenshotFunctionMutation,
  useScreenshotMutation,
} from "./dataApiSlice";
import { handlePublish } from "./components/WorkbookComponets/HandlePushlishComp";
import { getSheetControls, setSheetControls } from "./WorkbookControllingSlice";
import ActionModal from "./components/WorkbookPopups/Actions/ActionModal";
import SortModal from "./components/WorkbookPopups/Sorting/SortModal";
import useTitle from "../../hooks/useTitle";
import Header2 from "./components/WorkbookComponets/Header2";
import Aside4 from "./Aside4";
import AddNewDataSource from "./components/WorkbookPopups/AddNewDataSource";
import useAuth from "../../hooks/useAuth";
import { MdOutlineDashboard } from "react-icons/md";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import SQLQueryModal from "./components/WorkbookComponets/SQLQueryModal";

export default function Workbook() {
  useTitle("Vizta Workbook");
  const SheetNameBtm = useSelector((state) => {
    return selectTodoDescriptionsProxy(state);
  });
  // // console.log(SheetNameBtm);
  const PublishedId = useSelector((state) =>
    getWorkbookProperty(state, "publishId")
  );
  const workbook_ID = useSelector((state) => getWorkbookProperty(state, "_id"));
  const workbook_SelectedSheetID = useSelector((state) =>
    getWorkbookProperty(state, "selectedSheetId")
  );
  const { roles } = useAuth();
  const { setToast, callFunction, handleDownloadImage } = useMyContext();
  const buttonRef = useRef();

  const SheeType = SheetNameBtm.map((item) => item.sheetType).join(" ");

  // Redux funtions
  const selectedSheetIndex = SheetNameBtm.findIndex(
    (sheet) => sheet.selectedSheet === true
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentSheet, setCurrentSheet] = useState({
    SheetName: "",
    Sheetid: "",
    index: 0,
    dataSourceID: "",
  });
  const [VizType, setVizType] = useState("simpleTable");
  // console.log(VizType);
  const [viewPublishedButton, setViewPublishedButton] = useState(false);
  const [currentSheetIsDashboard, setCurrentSheetisDashboard] = useState(false);
  useEffect(() => {
    if (selectedSheetIndex >= 0) {
      const { ID, SheetName, VizType, dataSourceID, sheetType } =
        SheetNameBtm[selectedSheetIndex];
      // console.log(VizType);
      setVizType(VizType);
      setCurrentSheet({
        Sheetid: ID,
        SheetName,
        index: selectedSheetIndex,
        dataSourceID,
      });
      setCurrentSheetisDashboard(sheetType === "dashboard");
    }
  }, [selectedSheetIndex, SheetNameBtm]);

  const [openModal, setopenMOdal] = useState(false);
  const handleModal = () => {
    setopenMOdal(true);
  };
  const closeModal = () => {
    setopenMOdal(false);
  };

  const [publishModal, setPublishModal] = useState(false);
  // console.log(publishModal);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setViewPublishedButton(false);
      }
    };

    if (viewPublishedButton) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [viewPublishedButton]);

  const handleCallFunction = (id, downloadType, imageFormat) => {
    if (id) {
      callFunction(id, downloadType, imageFormat);
    } else {
      console.error(
        `something went wrong while downloading the data try again later`
      );
    }
  };

  // const

  const handleKeyZ = useCallback((e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "z") {
      e.preventDefault();
      // console.log("Ctrl+Z pressed");
      dispatch(ActionCreators.undo());
    }
  });
  const handleKeyY = useCallback((e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "y") {
      e.preventDefault();
      // console.log("Ctrl+Z pressed");
      dispatch(ActionCreators.redo());
    }
  });
  useEffect(() => {
    window.addEventListener("keydown", handleKeyZ);
    window.addEventListener("keydown", handleKeyY);
    return () => {
      window.removeEventListener("keydown", handleKeyZ);
      window.removeEventListener("keydown", handleKeyY);
    };
  }, [handleKeyZ]);
  // // console.log(currentSheet.Sheetid);
  const sheetAvlIndex = SheetNameBtm.findIndex(
    (sheet) => sheet.ID === currentSheet.Sheetid
  );
  // // console.log(sheetAvlIndex);
  const [
    pactchWorkbook,
    {
      data,
      isError: isPublishError,
      isLoading: isPublishLoading,
      isSuccess: isPublishSuccess,
      error: publishError,
    },
  ] = usePatchWorkbookMutation();
  const [
    getVizardData,
    {
      data: vizardData,
      isLoading: isVizardLoading,
      isError: isVizardError,
      isSuccess: isVizardSuccess,
      error: vizardError,
    },
  ] = useGetVizardDataMutation();

  const [
    screenshotFunction,
    {
      data: screenshotData,
      isLoading: isScreenshotLoading,
      isSuccess: isScreenshotSuccess,
      isError: isScreenshotError,
      error: screenshotError,
    },
  ] = useScreenshotFunctionMutation();

  const reduxIsPause =
    useSelector(
      getSheetControls({ Sheetid: currentSheet?.Sheetid, key: "isPause" })
    ) || false;
  const [pause, setPause] = useState(reduxIsPause);
  const [animationOff, setAnimationOff] = useState(false);
  const [actionModal, setActionModal] = useState(false);
  const [sortModal, setSortModal] = useState(false);
  const [sqlModal, setSqlModal] = useState(false);
  const [isAside4Visible, setIsAside4Visible] = useState(
    roles.includes("Creator") || roles.includes("Admin") ? true : false
  );
  const [dataSourceModal, setDataSourceModal] = useState(false);
  // console.log(dataSourceModal);
  const currentSheetQuery = useSelector((state) =>
    getL1SheetProperty(state, currentSheet.Sheetid, "query")
  );

  useEffect(() => {
    if (currentSheet?.Sheetid) {
      dispatch(
        setSheetControls({
          Sheetid: currentSheet.Sheetid,
          controls: {
            isPause: pause,
            isAnimataionOff: animationOff,
            uniqueColumnValues: [],
            sheetQuery: currentSheetQuery,
          },
          calledFrom: "workbook",
        })
      );
    }
  }, [pause, animationOff, currentSheet?.Sheetid, dispatch]);

  useEffect(() => {
    if (isScreenshotLoading) {
      setToast({
        message: "screenshot is genrating...., Please do not leave the page",
      });
    }
  }, [isScreenshotLoading]);

  const handlePlayPause = () => {
    setPause((prevPause) => !prevPause);
  };
  const handleAnimatation = () => {
    setAnimationOff((prevAnimataion) => !prevAnimataion);
  };

  const handleImageClick = () => {
    navigate("/home/dash");
  };

  const MemoizedReduxAside1 = useMemo(
    () => (
      <ReduxAside1
        dataSourceID={currentSheet.dataSourceID}
        Sheetid={currentSheet.Sheetid}
      />
    ),
    [currentSheet.dataSourceID]
  );
  const MemoizedAside2 = useMemo(
    () => (
      <Aside2
        currentSheet={currentSheet}
        dataSourceID={currentSheet.dataSourceID}
      />
    ),
    [currentSheet]
  );
  const MemoizedAside3 = useMemo(
    () => (
      <Aside3
        key={currentSheet.Sheetid}
        currentSheet={currentSheet}
        SheeType={SheeType}
        vizType={VizType}
        workbookType={"draft"}
        widthHeightObject={null}
        isVizardLoading={isVizardLoading}
        isVizardError={isVizardError}
        vizardError={vizardError}
        workbook_ID={workbook_ID}
        screenshotFunction={screenshotFunction}
        setToast={setToast}
      />
    ),
    [
      VizType,
      SheeType,
      publishModal,
      currentSheet,
      isVizardLoading,
      isVizardError,
      vizardError,
      screenshotFunction,
      setToast
    ]
  );
  const MemoizedAside4 = useMemo(
    () => (
      <Aside4
        Sheetid={currentSheet.Sheetid}
        vizType={VizType}
        getVizardData={getVizardData}
        vizardData={vizardData}
        isVizardLoading={isVizardLoading}
        isVizardError={isVizardError}
        vizardError={vizardError}
      />
    ),
    [
      isAside4Visible,
      currentSheet,
      getVizardData,
      vizardData,
      isVizardLoading,
      isVizardError,
      vizardError,
    ]
  );

  if (!currentSheet.Sheetid || sheetAvlIndex < 0) return null;
  // console.log(currentSheet);

  return (
    <>
      <section
        id="workbookSection"
        className="w-full h-screen flex flex-col gap-[1px] m-0 p-0 overflow-hidden"
      >
        {/* header 1  */}
        <header
          id="header1"
          className="bg-blue-950 h-[41px] flex items-center justify-between text-white w-full min-h-[38px]"
        >
          {/* left-side */}
          <div
            className="flex items-start justify-start h-[69%] w-[33%] pl-2"
            id="header1-div1"
          >
            <img
              src="/graph_img/viztaa.png"
              alt="brand_logo"
              className="h-full cursor-pointer"
              onClick={handleImageClick}
            />
          </div>
          {/* center */}
          <div
            className="flex items-center justify-center gap-6 text-base h-10 sm:w-0 md:w-[45%] w-[33%]"
            id="header1-div2"
          >
            <BackButtonDetector />
          </div>
          {/* right-side */}
          <div
            className="flex items-center justify-end pr-6 gap-6 text-base h-10 sm:w-[65%] md:w-[45%] w-[33%] space-x-2"
            id="header1-div3"
          >
            <DraftSaveComponent
              isPublishError={isPublishError}
              publishError={publishError}
              isPublishLoading={isPublishLoading}
              isPublishSuccess={isPublishSuccess}
            />
            {/* publish As / publish */}
            <div className="flex items-center justify-center">
              {PublishedId !== undefined && PublishedId[0] ? (
                <div className="w-auto min-w-[7rem] text-[14px] tracking-wide flex flex-col gap-2 justify-between items-center border rounded text-white hover:border-gray-400 relative">
                  <div className="flex items-center justify-between gap-2">
                    <button
                      className="w-auto text-[14px] tracking-wide flex gap-2 justify-between items-center px-[6px]"
                      onClick={() => handlePublish(pactchWorkbook)}
                    >
                      <AiOutlineSave className="text-[18px]" /> Publish
                    </button>
                    <button
                      onClick={() =>
                        setViewPublishedButton(!viewPublishedButton)
                      }
                      className="text-center w-auto"
                    >
                      {!viewPublishedButton ? (
                        <IoMdArrowDropdown className="text-xl text-center text-white border-l cursor-pointer hover:border-gray-400" />
                      ) : (
                        <IoMdArrowDropup className="text-xl text-center text-white border-l cursor-pointer hover:border-gray-400" />
                      )}
                    </button>
                  </div>
                  {viewPublishedButton ? (
                    <button
                      ref={buttonRef}
                      className="absolute rounded top-full left-[0] right-0 bg-white shadow-md mt-1 z-30 w-[7rem] text-blue-950 font-medium flex gap-2 items-center justify-center"
                      onClick={() =>
                        window.open(
                          `/dashboard?workbookid=${workbook_ID}&sheetid=${workbook_SelectedSheetID}`,
                          "_blank"
                        )
                      }
                    >
                      <MdOutlineDashboard />
                      Preview
                    </button>
                  ) : null}
                </div>
              ) : (
                <div className="w-auto min-w-[8rem] text-[14px] tracking-wide flex flex-col gap-2 justify-between items-center border rounded text-white hover:border-gray-400 relative">
                  <div className="flex items-center justify-between gap-2">
                    <button
                      className="flex w-auto items-center justify-center gap-2"
                      onClick={() => setPublishModal(true)}
                    >
                      <AiOutlineSave className="text-[18px]" /> Publish As
                    </button>
                    <button
                      onClick={() =>
                        setViewPublishedButton(!viewPublishedButton)
                      }
                      className="text-center w-auto"
                    >
                      {!viewPublishedButton ? (
                        <IoMdArrowDropdown className="text-xl text-center text-white border-l border-white cursor-pointer" />
                      ) : (
                        <IoMdArrowDropup className="text-xl text-center text-white border-l border-white cursor-pointer" />
                      )}
                    </button>
                  </div>
                  {viewPublishedButton ? (
                    <button
                      ref={buttonRef}
                      className="absolute rounded top-full left-[0] right-0 bg-white shadow-md mt-1 z-30 w-[8rem] text-blue-950 font-medium flex gap-2 items-center justify-center"
                      onClick={() =>
                        window.open(
                          `/dashboard?workbookid=${workbook_ID}&sheetid=${workbook_SelectedSheetID}`,
                          "_blank"
                        )
                      }
                    >
                      <MdOutlineDashboard />
                      Preview
                    </button>
                  ) : null}
                </div>
              )}
            </div>
            <span className="cursor-pointer">
              <DropDownComp />
            </span>
          </div>
        </header>

        {/* header 2 */}
        <Header2
          pause={pause}
          animationOff={animationOff}
          actionModal={actionModal}
          sortModal={sortModal}
          handlePlayPause={handlePlayPause}
          handleAnimatation={handleAnimatation}
          setActionModal={setActionModal}
          setSortModal={setSortModal}
          currentSheetIsDashboard={currentSheetIsDashboard}
          handleCallFunction={handleCallFunction}
          handleDownloadImage={handleDownloadImage}
          currentSheet={currentSheet}
          handleModal={handleModal}
          VizType={VizType}
          sheetsArrayLength={SheetNameBtm.length}
          isAside4Visible={isAside4Visible}
          setIsAside4Visible={setIsAside4Visible}
          setDataSourceModal={setDataSourceModal}
          Sheetid={currentSheet.Sheetid}
          roles={roles}
          setSqlModal={setSqlModal}
          setToast={setToast}
        />

        {/* Render asides dynamically based on currentAside state */}
        {currentSheetIsDashboard ? (
          <>
            <Dashboard
              key={currentSheet.Sheetid}
              currentSheet={currentSheet}
              SheeType={SheeType}
            />
          </>
        ) : (
          <main className="overflow-x-hidden flex w-[99.85%] h-[86.5vh] ml-[1.8px]">
            {/* Render content based on the current sheet */}
            <aside
              id="aside1"
              className="flex flex-col gap-2 overflow-hidden rounded border border-gray-200 shadow-md w-[14%] h-full mx-[0.3px]"
            >
              {MemoizedReduxAside1}
            </aside>
            <aside
              id="aside2"
              className="flex flex-col overflow-hidden  rounded border  border-gray-200 shadow-md w-[14%] mx-[0.3px] h-full"
            >
              {MemoizedAside2}
            </aside>
            <section className="flex flex-col h-full w-[72%] mx-[0.3px]">
              {isAside4Visible ? (
                <aside
                  id="aside4"
                  className="flex overflow-x-hidden overflow-y-hidden rounded border border-gray-200 w-full h-[5.2%]"
                >
                  {MemoizedAside4}
                </aside>
              ) : null}
              <aside
                id="aside3"
                className={`flex overflow-x-hidden overflow-y-hidden rounded border  border-gray-200 w-full ${
                  isAside4Visible ? "h-[94.8%] border-t-0" : "h-full "
                }`}
              >
                {MemoizedAside3}
              </aside>
            </section>
          </main>
        )}

        {/* footer  */}
        <Footer
          SheetNameBtm={SheetNameBtm}
          selectedSheetIndex={selectedSheetIndex}
          selectedSheetId={currentSheet.Sheetid}
        />
      </section>
      {openModal && (
        <VizStyle
          closeModal={closeModal}
          SheetDetails={currentSheet}
          setVizType={setVizType}
          currentVizTpe={VizType}
        />
      )}
      {openModal && <div />}
      {publishModal ? (
        <PublishWorkbook
          closeModal={() => setPublishModal(false)}
          dataSourceID={currentSheet["dataSourceID"]}
        />
      ) : null}
      {actionModal ? (
        <ActionModal
          closeModal={() => setActionModal(false)}
          selectedSheetId={currentSheet.Sheetid}
          VizType={VizType}
        />
      ) : null}
      {sortModal ? (
        <SortModal
          closeModal={() => setSortModal(false)}
          selectedSheetId={currentSheet.Sheetid}
          VizType={VizType}
        />
      ) : null}
      {dataSourceModal ? (
        <AddNewDataSource closeModal={() => setDataSourceModal(false)} />
      ) : null}
      {sqlModal ? (
        <SQLQueryModal
          closeModal={() => setSqlModal(false)}
          currentSheet={currentSheet}
        />
      ) : null}
    </>
  );
}
